import React, { useState, useEffect } from 'react';
import CryptoJS from "crypto-js";
import { ChevronLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useTicket } from '../../../context/TicketContext';

const CheckoutTicket2 = ({ eventID="67484c0a712f39db7b885fd6" }) => {
  const navigate = useNavigate();
  const { ticketDetails, updateTicketDetails } = useTicket();
  
  // Load ticket details from localStorage if TicketContext is empty
  useEffect(() => {
    const storedData = localStorage.getItem("kagoTicketDetails");
    if (storedData) {
      try {
        const parsedData = JSON.parse(storedData);
        // Only update if TicketContext is empty or has zero total
        if (!ticketDetails.tickets?.length || ticketDetails.total === 0) {
          updateTicketDetails(parsedData);
        }
      } catch (error) {
        console.error("Error parsing ticket details from localStorage:", error);
      }
    }
  }, []); // Run once on mount

  // Use TicketContext data, fallback to localStorage if needed (for immediate render)
  const storedData = localStorage.getItem("kagoTicketDetails");
  let finalTicketDetails = ticketDetails;
  
  if ((!ticketDetails.tickets?.length || ticketDetails.total === 0) && storedData) {
    try {
      finalTicketDetails = JSON.parse(storedData);
    } catch (error) {
      console.error("Error parsing ticket details from localStorage:", error);
    }
  }
  
  const { tickets = [], total = 0, eventDetails = null } = finalTicketDetails || {};
  
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');

  const handleBackClick = () => {
    navigate(-1);
  };

  // const merchantInfo = {
  //   merchantId: "10038016",
  //   merchantKey: "wli6oa7t5uzfg",
  //   passPhrase: "ShadowSketch2025"
  // };  
  const merchantInfo = {
    merchantId: "15207408",
    merchantKey: "j2nwmhfqg96yr",
    passPhrase: "TNGSolutions2023"
  };  
   
  const generateSignature = (data, passPhrase = null) => {
    let dataToSign = { ...data };
  
    // ✅ Add passphrase to the data BEFORE sorting
    if (passPhrase !== null) {
      dataToSign.passphrase = passPhrase.trim();
    }
  
    // ✅ Sort the keys
    const ordered = {};
    Object.keys(dataToSign)
      .sort()
      .forEach(key => {
        ordered[key] = dataToSign[key];
      });
  
    // ✅ Generate getString
    let getString = '';
    for (let key in ordered) {
      const value = encodeURIComponent(ordered[key]).replace(/%20/g, '+');
      getString += `${key}=${value}&`;
    }
  
    // ✅ Remove trailing &
    getString = getString.slice(0, -1);
  
    return CryptoJS.MD5(getString).toString();
  };
  
  const handleCompletePurchase = (e) => {
    e.preventDefault();

    // Validate that there are tickets and total is greater than 0
    if (!tickets?.length || total === 0 || !total) {
      alert("Please select at least one ticket before proceeding to payment.");
      return;
    }

    const myData = {
      merchant_id: merchantInfo.merchantId,
      merchant_key: merchantInfo.merchantKey,
      return_url: "https://events.kago.digital/registrations",
      cancel_url: "https://events.kago.digital/cancel",
      notify_url: "https://event-kago-node-f8e27b60f1f9.herokuapp.com/api/v1/attendees/attendee-ticket-notify/67484c0a712f39db7b885fd6",
      name_first: firstName || "Test",
      name_last: lastName || "User",
      email_address: email || "uset@gmail.com",
      cell_number: phone || "0605237089",
      m_payment_id: `${eventID}-${Date.now()}`,
      amount: total.toFixed(2).toString(),
      item_name: "Standard",
    };

    myData.signature = generateSignature(myData, merchantInfo.passPhrase);
    console.log("myData", JSON.stringify(myData, null, 2));

    // let form;
    const form = document.createElement("form");
    form.action = "https://www.payfast.co.za/eng/process";
    form.method = "post";
    form.id = "payment-form";

    Object.keys(myData).sort().forEach(key => {
      if (myData[key] !== "") {
        const hiddenInput = document.createElement("input");
        hiddenInput.type = "hidden";
        hiddenInput.name = key;
        hiddenInput.value = myData[key].toString().trim();
        form.appendChild(hiddenInput);
      }
    });

    document.body.appendChild(form);
    form.submit();
  };

  return (
    <div id="checkout-container" style={{ maxWidth: '800px', margin: '0 auto', padding: '2rem' }}>
      <form onSubmit={handleCompletePurchase}>
        {/* Back Button */}
        <button 
          onClick={handleBackClick}
          style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '0.5rem',
            background: 'none',
            border: 'none',
            color: '#6366f1',
            cursor: 'pointer',
            marginBottom: '2rem',
            padding: 0
          }}
        >
          <ChevronLeft size={20} />
          <span>Back to Ticket Selection</span>
        </button>

        {/* Purchaser Information */}
        <div style={{ 
          backgroundColor: 'white',
          borderRadius: '0.5rem',
          padding: '1.5rem',
          marginBottom: '1.5rem',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
        }}>
          <h2 style={{ 
            fontSize: '1.25rem',
            fontWeight: '600',
            marginBottom: '1rem'
          }}>
            Purchaser Information
          </h2>
          <p style={{ 
            color: '#6b7280',
            marginBottom: '1rem'
          }}>
            Please enter your details
          </p>
          {/* First Row - First Name and Last Name */}
          <div style={{ 
            display: 'flex', 
            gap: '1rem',
            marginBottom: '1rem'
          }}>
            <div style={{ flex: 1 }}>
              <label 
                htmlFor="firstName"
                style={{
                  display: 'block',
                  marginBottom: '0.5rem',
                  fontWeight: '500'
                }}
              >
                First Name
              </label>
              <input
                id="firstName"
                type="text"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                placeholder="Enter your first name"
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '1px solid #e5e7eb',
                  borderRadius: '0.375rem',
                  fontSize: '1rem'
                }}
              />
            </div>
            <div style={{ flex: 1 }}>
              <label 
                htmlFor="lastName"
                style={{
                  display: 'block',
                  marginBottom: '0.5rem',
                  fontWeight: '500'
                }}
              >
                Last Name
              </label>
              <input
                id="lastName"
                type="text"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                placeholder="Enter your last name"
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '1px solid #e5e7eb',
                  borderRadius: '0.375rem',
                  fontSize: '1rem'
                }}
              />
            </div>
          </div>
          {/* Second Row - Email and Phone */}
          <div style={{ 
            display: 'flex', 
            gap: '1rem'
          }}>
            <div style={{ flex: 1 }}>
              <label 
                htmlFor="email"
                style={{
                  display: 'block',
                  marginBottom: '0.5rem',
                  fontWeight: '500'
                }}
              >
                Email
              </label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '1px solid #e5e7eb',
                  borderRadius: '0.375rem',
                  fontSize: '1rem'
                }}
              />
            </div>
            <div style={{ flex: 1 }}>
              <label 
                htmlFor="phone"
                style={{
                  display: 'block',
                  marginBottom: '0.5rem',
                  fontWeight: '500'
                }}
              >
                Phone Number
              </label>
              <input
                id="phone"
                type="tel"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="Enter your phone number"
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '1px solid #e5e7eb',
                  borderRadius: '0.375rem',
                  fontSize: '1rem'
                }}
              />
            </div>
          </div>
        </div>

        {/* Order Summary */}
        <div style={{ 
          backgroundColor: 'white',
          borderRadius: '0.5rem',
          padding: '1.5rem',
          marginBottom: '1.5rem',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
        }}>
          <h2 style={{ 
            fontSize: '1.25rem',
            fontWeight: '600',
            marginBottom: '1rem'
          }}>
            Order Summary
          </h2>
          {!tickets?.length || total === 0 ? (
            <p style={{ color: '#ef4444', marginBottom: '1rem' }}>
              No tickets selected. Please go back and select tickets.
            </p>
          ) : (
            <>
              {tickets.map((ticket, index) => (
                <div key={index} style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginBottom: '0.75rem'
                }}>
                  <span>{ticket.quantity} x {ticket.tier || ticket.name || 'Ticket'}</span>
                  <span>R {ticket.price?.toFixed(2) || '0.00'}</span>
                </div>
              ))}
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginBottom: '0.75rem',
                paddingTop: '0.75rem',
                borderTop: '1px solid #e5e7eb'
              }}>
                <span>Subtotal</span>
                <span>R {(total || 0).toFixed(2)}</span>
              </div>
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                fontWeight: '600',
                fontSize: '1.125rem'
              }}>
                <span>Total</span>
                <span>R {(total || 0).toFixed(2)}</span>
              </div>
            </>
          )}
        </div>

        {/* Complete Purchase Button */}
        <button 
          type="submit" 
          style={{
            width: '100%',
            background: "linear-gradient(to right, rgb(247, 152, 60), rgb(255, 124, 110))",
            color: 'white',
            padding: '0.75rem',
            borderRadius: '0.375rem',
            border: 'none',
            fontSize: '1rem',
            fontWeight: '500',
            cursor: 'pointer',
          }}
        >
          Complete Purchase
        </button>
      </form>
    </div>
  );
};

export default CheckoutTicket2;
